import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=45a68695&"
import script from "./VideoElement.vue?vue&type=script&lang=js&"
export * from "./VideoElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports